



/**
 * 数组转树  非递归求解
 * 利用数组和对象相互引用  时间复杂度O(n)
 * 
 * @param {Object} list
 */
 export function ListToTree(data, parId) {
     // 使用深拷贝数据
    let list = [...data].map(item => {
        return {...item};
    });
    let obj = {};
    let result = [];
    list.map(el => {
        obj[el.oid] = el;
    })
    for(let i=0, len = list.length; i < len; i++) {
        let id = list[i].parentid;
        if(id == parId) {
            result.push(list[i]);
            continue;
        }
        if(obj[id].children) {
            obj[id].children.push(list[i]);
        } else {
            obj[id].children = [list[i]];
        }
    }

    return result;
}





/**
 * 检查手机号
 * 
 * @param {*} rule 
 * @param {*} value 
 * @param {*} callback 
 * @returns 
 */
export function ValidateFormPhone(rule, value, callback) {
    if (!value) {
        callback(new Error('请输入手机号!'))
      } else {
        const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('请输入正确的手机号!'));
        }
      }
}



/**
 * 验证身份证
 * 
 * @param {*} rule 
 * @param {*} value 
 * @param {*} callback 
 */
export function ValidateFormIdNum(rule, value, callback) {

    if (!value || value == '') {
      // 数据不能为空
      callback(new Error('身份证号不能为空!'));
      return;
    }


    var city = {
        11: '北京',
        12: '天津',
        13: '河北',
        14: '山西',
        15: '内蒙古',
        21: '辽宁',
        22: '吉林',
        23: '黑龙江 ',
        31: '上海',
        32: '江苏',
        33: '浙江',
        34: '安徽',
        35: '福建',
        36: '江西',
        37: '山东',
        41: '河南',
        42: '湖北 ',
        43: '湖南',
        44: '广东',
        45: '广西',
        46: '海南',
        50: '重庆',
        51: '四川',
        52: '贵州',
        53: '云南',
        54: '西藏 ',
        61: '陕西',
        62: '甘肃',
        63: '青海',
        64: '宁夏',
        65: '新疆',
        71: '台湾',
        81: '香港',
        82: '澳门',
        91: '国外 '
      }
      // var tip = ''
      var pass = true

      var patt1 = new RegExp(
        '(^[1-9]\\d{5}(18|19|([23]\\d))\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}[0-9Xx]$)|(^[1-9]\\d{5}\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{2}$)'
      )
      if (!patt1.test(value)) {
        callback(new Error('身份证号格式错误!'));
        pass = false
      } else if (!city[value.substr(0, 2)]) {
        callback(new Error('地址编码错误!'));
        pass = false
      } else {
        //18位身份证需要验证最后一位校验位
        if (value.length == 18) {
          value = value.split('')
          //∑(ai×Wi)(mod 11)
          //加权因子
          var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
          //校验位
          var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
          var sum = 0
          var ai = 0
          var wi = 0
          for (var i = 0; i < 17; i++) {
            ai = value[i]
            wi = factor[i]
            sum += ai * wi
          }
          var last = parity[sum % 11]
          if (last != value[17]) {
            callback(new Error('身份证号码错误'))
            pass = false
          }
        }
      }
      if (pass) {
        callback()
      }


}





/**
 * 验证邮箱
 * 
 * @param {*} rule 
 * @param {*} value 
 * @param {*} callback 
 * @returns 
 */
export function ValidateFormEmail(rule, value, callback) {
    const regEmail = /^([a-zA-Z]|[0-9])(\w|)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
      if (regEmail.test(value)) {
        // 合法的邮箱
        return callback();
      }
      callback(new Error('请输入正确的邮箱'));
}

































